// Content data for Shiv Shakti Enterprises.
// Marketing/content lives here; auth, quotes and contact are backed by the API.

export const company = {
  name: "Shiv Shakti Enterprises",
  nameParts: { light: "shiv shakti", bold: "enterprises" },
  tagline: "Your Global Partner in Manufacturing",
  phone: "+91 93247 04044",
  phoneHref: "+919324704044",
  whatsapp: "+91 93247 04044",
  whatsappHref: "919324704044",
  email: "info@shivshaktienterprisesglobal.in",
  address: "H No-SL09/6577, S No-78, 0, Tungareshwar Road, NR T/F, V, Vasai East, Vasai Virar, Palghar, Maharashtra, 401208",
  hours: "Mon \u2013 Sat: 9:00 AM \u2013 6:30 PM",
  facilitySize: "10,000+",
  employees: "100+",
  location: "Vasai East, Maharashtra",
};

export const heroBg =
  "https://images.unsplash.com/photo-1594383538644-66fcb99ae1ed?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600";

export const aboutImage =
  "https://images.unsplash.com/photo-1647427060118-4911c9821b82?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200";

export const navLinks = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  { label: "Products We Manufacture", to: "/#products", dropdown: "products" },
  { label: "Services", to: "/#services", dropdown: "services" },
  { label: "Contact", to: "/contact" },
];

export const products = [
  {
    slug: "cnc-machining",
    title: "CNC Machining",
    short: "High-precision CNC turned and milled components to tight tolerances.",
    image: "https://images.unsplash.com/photo-1740209475472-aa7d280f7452?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    description:
      "Multi-axis CNC machining for precision components in steel, stainless steel, aluminium, brass and engineering plastics \u2014 from single prototypes to regular production batches, all produced in-house at our Vasai East facility.",
    features: ["3, 4 & 5-axis machining", "Tolerances to \u00b10.01mm", "Prototypes to production", "Full material traceability"],
  },
  {
    slug: "vmc-machining",
    title: "VMC Machining",
    short: "Vertical machining centre work for complex, accurate parts.",
    image: "https://images.unsplash.com/photo-1717386255773-1e3037c81788?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    description:
      "Our Vertical Machining Centres (VMC) produce complex, close-tolerance components with an excellent surface finish \u2014 ideal for dies, moulds, fixtures and precision engineered parts.",
    features: ["High-speed VMC", "Complex 3D profiles", "Dies, moulds & fixtures", "Repeatable accuracy"],
  },
  {
    slug: "aluminium-die-casting",
    title: "Aluminium Die Casting",
    short: "Pressure die cast aluminium parts, machined and finished.",
    image: "https://images.unsplash.com/photo-1613970351372-9804e380bd09?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    description:
      "Aluminium die casting for lightweight, dimensionally stable components. We manage tooling, casting, machining and finishing to deliver ready-to-use parts to your specification.",
    features: ["Pressure die casting", "In-house tooling", "Machining & finishing", "Lightweight alloys"],
  },
  {
    slug: "fiber-laser-cutting",
    title: "Fiber Laser Cutting",
    short: "Fast, clean fiber laser cutting for sheet and plate.",
    image: "https://images.unsplash.com/photo-1738162837451-2041c1418f54?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    description:
      "High-precision fiber laser cutting delivers clean edges and tight tolerances on mild steel, stainless steel and aluminium sheet and plate \u2014 with fast turnaround for both prototypes and volume runs.",
    features: ["CNC fiber laser", "Sheet & plate cutting", "Tight tolerances", "Fast turnaround"],
  },
  {
    slug: "sheet-metal-fabrication",
    title: "Sheet Metal Fabrication",
    short: "Cutting, bending, welding and finished fabricated assemblies.",
    image: "https://images.unsplash.com/photo-1504328345606-18bbc8c9d7d1?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    description:
      "Complete sheet metal fabrication \u2014 laser cutting, CNC bending, welding and finishing \u2014 to produce enclosures, brackets, panels and welded assemblies ready to install.",
    features: ["CNC bending", "MIG / TIG welding", "Enclosures & panels", "Finishing & coating"],
  },
  {
    slug: "precision-components",
    title: "Precision Components",
    short: "Tight-tolerance precision-engineered components to spec.",
    image: "https://images.unsplash.com/photo-1666634157070-6fd830fb5672?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    description:
      "Precision-engineered components manufactured to your drawings with rigorous dimensional control and inspection \u2014 trusted by OEMs, equipment manufacturers and industrial buyers.",
    features: ["Made to drawing", "Dimensional inspection", "Tight tolerances", "OEM-grade quality"],
  },
  {
    slug: "custom-industrial-manufacturing",
    title: "Custom Industrial Manufacturing",
    short: "Customized end-to-end manufacturing for your project.",
    image: "https://images.unsplash.com/photo-1647427060118-4911c9821b82?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    description:
      "From individual components and prototypes to regular production, we take on customized manufacturing requirements end-to-end \u2014 engineering, production, quality control and support, all under one roof.",
    features: ["Prototypes to production", "Custom requirements", "End-to-end delivery", "Dedicated support"],
  },
];

export const services = [
  { slug: "concept", title: "Concept", icon: "Lightbulb", tagline: "From Idea to Reality: Turn Your Concept into a Manufacturable Product", description: "We help you shape a raw idea into a viable, manufacturable product \u2014 evaluating feasibility, materials and cost before a single part is made." },
  { slug: "design", title: "Design", icon: "Ruler", tagline: "Where Design Meets Engineering: From Spec to Production", description: "Our engineering team translates your specification into production-ready drawings and 3D models, optimised for manufacturing and cost." },
  { slug: "prototyping", title: "Prototyping", icon: "Boxes", tagline: "Bring Your Vision to Life: Prototyping for Success", description: "Rapid prototypes let you validate form, fit and function before committing to production tooling, reducing risk and speeding time to market." },
  { slug: "sampling", title: "Sampling", icon: "FlaskConical", tagline: "No Surprises: Our Guarantee of Quality Through Sampling", description: "Pre-production samples are inspected and approved against your specification so there are no surprises when full production begins." },
  { slug: "production", title: "Production", icon: "Factory", tagline: "Effortless In-House Production: Your Success is Our Priority", description: "We manage your production run end-to-end on our own factory floor, keeping quality, price and delivery firmly on track." },
  { slug: "quality", title: "Quality", icon: "ShieldCheck", tagline: "Unwavering Quality: Your Guarantee of Consistency", description: "Rigorous inspection and documented quality control at every stage ensure consistent, virtually flawless parts, batch after batch." },
  { slug: "packaging", title: "Packaging", icon: "Package", tagline: "Packaging Solutions for Safe Delivery", description: "Protective and custom packaging solutions keep your parts safe in transit and presentation-perfect on arrival." },
  { slug: "logistics", title: "Logistics", icon: "Truck", tagline: "Effortless Delivery: From Our Factory to Your Doorstep", description: "We handle freight, dispatch and warehousing so your parts arrive on time, every time \u2014 from our factory floor to your doorstep." },
];

export const testimonials = [
  { quote: "Original and with an innate understanding of their customer\u2019s needs, the team at Shiv Shakti Enterprises are always a pleasure to work with.", name: "Jane Miller", role: "Procurement Lead", avatar: "https://ui-avatars.com/api/?name=Jane+Miller&background=D80000&color=fff&size=128" },
  { quote: "They took complete ownership of our project from design to delivery. Quality and turnaround exceeded our expectations.", name: "Rahul Deshmukh", role: "Operations Director", avatar: "https://ui-avatars.com/api/?name=Rahul+Deshmukh&background=1a1a1a&color=fff&size=128" },
];

export const stats = [
  { value: "100+", label: "Skilled Employees" },
  { value: "10,000+", label: "Sq. Ft. Facility" },
  { value: "7", label: "Core Capabilities" },
  { value: "6+", label: "Industries Served" },
];

// NOTE: Certifications are PLACEHOLDERS \u2014 replace with the ones you actually hold.
export const certifications = [
  { code: "ISO 9001:2015", label: "Quality Management", icon: "Award" },
  { code: "ISO 14001:2015", label: "Environmental", icon: "Leaf" },
  { code: "IATF 16949", label: "Automotive Quality", icon: "ShieldCheck" },
  { code: "CE", label: "European Conformity", icon: "BadgeCheck" },
];

// NOTE: Facility photos are professional STOCK placeholders \u2014 swap with real photos of your shop floor.
export const facilityGallery = [
  { src: "https://images.unsplash.com/photo-1740209475472-aa7d280f7452?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200", title: "CNC Machining Centre", category: "Machining" },
  { src: "https://images.unsplash.com/photo-1717386255773-1e3037c81788?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200", title: "VMC Machining", category: "Machining" },
  { src: "https://images.unsplash.com/photo-1647427060118-4911c9821b82?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200", title: "Shop Floor", category: "Facility" },
  { src: "https://images.unsplash.com/photo-1747999610489-de5c0ad00e56?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200", title: "Skilled Operators", category: "Our Team" },
  { src: "https://images.unsplash.com/photo-1758873263563-5ba4aa330799?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200", title: "Quality Inspection", category: "Quality" },
  { src: "https://images.unsplash.com/photo-1738162837451-2041c1418f54?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200", title: "Fiber Laser Cutting", category: "Fabrication" },
  { src: "https://images.unsplash.com/photo-1504328345606-18bbc8c9d7d1?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200", title: "Sheet Metal Fabrication", category: "Fabrication" },
  { src: "https://images.unsplash.com/photo-1553413077-190dd305871c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200", title: "Finished Goods Store", category: "Logistics" },
];
